module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "p-case u-pad-a-1 u-bg--white-near"
  }, [(_vm.c) ? _c('div', {
    staticClass: "p-case__container u-marg-x-auto u-w12of18 u-fit-w@sm"
  }, [(_vm.c.category) ? _c('div', {
    staticClass: "u-marg-x-auto u-w8of10@sm u-pad-r-w3of10 u-pad-r-0@sm"
  }, [_c('span', {
    staticClass: "t-text--xxs t-fweight--bold u-color--gray u-uppercase",
    domProps: {
      "innerHTML": _vm._s(_vm.c.category.short_title)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-case__container__wrapper__content u-marg-t-lg u-marg-x-auto@sm u-flex u-flex-fd--column@sm u-w8of10@sm",
    class: [!_vm.c.description || _vm.c.description.trim() === '' ? 'is-no-description' : '', !_vm.c.credits || _vm.c.credits.length === 0 ? 'is-no-credits' : '']
  }, [_c('div', {
    staticClass: "p-case__container__wrapper__title u-w6of12 u-w9of12@lg u-fit-w@sm"
  }, [_c('h1', {
    staticClass: "t-text--lg t-fweight--light t-ffamily--freight"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.c.title)
    }
  })]), _vm._v(" "), (_vm.c.description && _vm.c.description.trim() !== '') ? _c('p', {
    staticClass: "u-marg-t-xs t-text--sm u-color--gray",
    domProps: {
      "innerHTML": _vm._s(_vm.c.description)
    }
  }) : _vm._e()]), _vm._v(" "), ((_vm.c.credits && _vm.c.credits.length > 0) || (_vm.c.url && _vm.c.url.trim() !== '')) ? _c('aside', {
    staticClass: "p-case__container__credits u-marg-t-xs u-marg-t-xl@sm u-w6of12 u-fit-w@sm u-pad-l-w2of12 u-pad-l-0@sm"
  }, [_vm._l((_vm.c.credits), function(credit, index) {
    return (_vm.c.credits && _vm.c.credits.length > 0) ? _c('dl', {
      staticClass: "p-case__container__credits__credit"
    }, [_c('dt', {
      staticClass: "t-text--xxs t-fweight--bold u-color--black u-uppercase",
      domProps: {
        "innerHTML": _vm._s(credit.value.title)
      }
    }), _vm._v(" "), _c('dd', {
      staticClass: "t-text--sm u-color--gray",
      domProps: {
        "innerHTML": _vm._s(credit.value.content)
      }
    })]) : _vm._e()
  }), _vm._v(" "), (_vm.c.url && _vm.c.url.trim() !== '') ? _c('div', {
    staticClass: "p-case__container__credits__launch u-marg-t-xl"
  }, [_c('a', {
    staticClass: "t-link u-relative u-inline-block u-click-area-xxs",
    attrs: {
      "href": _vm.c.url,
      "target": "_blank",
      "rel": "nofollow noreferrer noopener"
    }
  }, [_c('div', {
    staticClass: "u-flex u-flex-ai--center"
  }, [_c('span', {
    staticClass: "t-text--xxs t-fweight--bold u-color--black u-uppercase"
  }, [_vm._v("Launch")]), _vm._v(" "), _c('img', {
    staticClass: "p-case__container__credits__launch__arrow u-marg-l-xs",
    attrs: {
      "src": "/static/medias/images/arrow-right--black.png",
      "alt": 'Launch ' + _vm.c.title,
      "title": 'Launch ' + _vm.c.title
    }
  })])])]) : _vm._e()], 2) : _vm._e()]), _vm._v(" "), _c('div', _vm._l((_vm.c.medias), function(media, index) {
    return _c('div', {
      staticClass: "u-marg-t-xxxl"
    }, [_c('div', {
      staticClass: "u-relative"
    }, [(media.value.file.video) ? _c('div', {
      staticClass: "p-case__container__case__media js-case-video-container"
    }, [_c('video', {
      staticClass: "js-case-video u-absolute u-pos-tl u-fit-w",
      attrs: {
        "controls": media.value.controls || _vm.$root.isTouch,
        "playsline": "",
        "loop": "",
        "preload": "auto",
        "muted": "",
        "poster": _vm.c.cover_poster ? _vm.$root.CONFIG.env.uploads + _vm.c.cover_poster.path : '',
        "title": 'Immersive Garden - ' + _vm.c.title,
        "alt": 'Immersive Garden - ' + _vm.c.title,
        "data-index": index
      },
      domProps: {
        "muted": true
      }
    }, [_c('source', {
      attrs: {
        "type": media.value.file.mime
      }
    })]), _vm._v(" "), (!_vm.$root.isTouch) ? _c('div', {
      staticClass: "p-case__container__case__media__overlay u-absolute u-pos-tl u-zindex--3 u-fit",
      class: [_vm.videosCanBePlayed.indexOf(index) !== -1 ? 'is-hidden' : '']
    }, [_vm._m(0, true)]) : _vm._e(), _vm._v(" "), (!_vm.$root.isTouch) ? _c('div', {
      staticClass: "p-case__container__case__media__poster u-absolute u-pos-tl u-zindex--2 u-fit",
      class: [_vm.videosCanBePlayed.indexOf(index) !== -1 ? 'is-hidden' : ''],
      style: ({
        'background-image': 'url(' + (_vm.$root.CONFIG.env.uploads + _vm.c.cover_poster.path) + ')',
        'background-size': 'cover',
        'background-repeat': 'no-repeat',
        'background-position': 'center'
      })
    }) : _vm._e()]) : (media.value.file.image) ? _c('img', {
      staticClass: "js-case-image u-fit-w",
      attrs: {
        "src": _vm.$root.CONFIG.env.uploads + media.value.file.path,
        "title": 'Immersive Garden - ' + _vm.c.title,
        "alt": 'Immersive Garden - ' + _vm.c.title
      }
    }) : _vm._e()]), _vm._v(" "), (media.value.caption && media.value.caption.trim() !== '') ? _c('p', {
      staticClass: "u-marg-t-xxxs u-fit-w u-pad-x-w1of12 t-text--xxs t-fweight--bold u-color--gray u-uppercase u-align-center",
      domProps: {
        "innerHTML": _vm._s(media.value.caption)
      }
    }) : _vm._e()])
  })), _vm._v(" "), _c('div', {
    staticClass: "p-case__previous-next u-relative u-flex u-flex-jc--center"
  }, [(_vm.c.previous_case) ? _c('div', {
    staticClass: "p-case__previous-next__item u-w1of2",
    class: [_vm.c.next_case ? 'is-right' : 'is-center']
  }, [_c('router-link', {
    staticClass: "p-case__previous-next__link u-relative u-click-area-xxs t-link",
    attrs: {
      "to": _vm.$root.getCaseURLFromSlug(_vm.c.previous_case.title_slug)
    }
  }, [_c('span', {
    staticClass: "t-text--xxs t-fweight--bold u-color--gray-dark u-uppercase"
  }, [_vm._v("Previous project")]), _vm._v(" "), _c('span', {
    staticClass: "p-case__previous-next__underline u-absolute u-pos-bl u-fit-w u-bg--black"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.c.next_case) ? _c('div', {
    staticClass: "p-case__previous-next__item u-w1of2",
    class: [_vm.c.previous_case ? 'is-left' : 'is-center']
  }, [_c('router-link', {
    staticClass: "p-case__previous-next__link u-relative u-click-area-xxs t-link",
    attrs: {
      "to": _vm.$root.getCaseURLFromSlug(_vm.c.next_case.title_slug)
    }
  }, [_c('span', {
    staticClass: "t-text--xxs t-fweight--bold u-color--gray-dark u-uppercase"
  }, [_vm._v("Next project")]), _vm._v(" "), _c('span', {
    staticClass: "p-case__previous-next__underline u-absolute u-pos-bl u-fit-w u-bg--black"
  })])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-case__previous-next__back-to-top u-absolute u-cursor-pointer u-click-area-xxs",
    on: {
      "click": function($event) {
        _vm.$root.scrollTo(0)
      }
    }
  }, [_c('img', {
    staticClass: "u-fit-h",
    attrs: {
      "src": "/static/medias/images/arrow-up--black.png",
      "alt": "Back to top",
      "title": "Back to top"
    }
  })])])]) : _c('div', {
    staticClass: "u-flex u-flex-ai--center u-flex-jc--center u-fit-v"
  }, [_c('span', {
    staticClass: "t-text--xs-l t-fweight--bold u-uppercase u-color--gray"
  }, [_vm._v("The case \"" + _vm._s(_vm.slug) + "\" doesn't exist ☹️")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-case__container__case__media__overlay__loader u-absolute u-pos-br"
  }, [_c('div', {
    staticClass: "p-case__container__case__media__overlay__loader-outer u-absolute u-pos-center u-bradius--circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-case__container__case__media__overlay__loader-inner u-absolute u-pos-center u-bradius--circle"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cd4585c"}!./src/scripts/components/page-case/template.html
// module id = 142
// module chunks = 0